import { __assign, __rest } from "tslib";
import React from 'react';
import { cnTextinput } from '../Textinput';
import './Textinput-Control.css';
export var TextinputControl = function (_a) {
    var _b = _a.autoComplete, autoComplete = _b === void 0 ? 'off' : _b, className = _a.className, controlRef = _a.controlRef, props = __rest(_a, ["autoComplete", "className", "controlRef"]);
    return (React.createElement("input", __assign({}, props, { ref: controlRef, className: cnTextinput('Control', null, [className]), autoComplete: autoComplete })));
};
